import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FaStore, FaArrowRight } from 'react-icons/fa'

import api from '../../api/api'
import { SectionHeader, Skeleton } from '../ui'
import SellerProfileCard from '../seller/SellerProfileCard'

// Önə çıxan satıcılar — public read-only of /sellers/active.
// No Redux. No writes. No dashboard endpoints. Error → silent hide.
// Kart dizaynı /magazalar səhifəsi ilə ortaq SellerProfileCard-dan gəlir.

// Boşluğu dolduran "bütün mağazalar" CTA kartı
const CtaCard = () => {
    const { t } = useTranslation()
    return (
    <Link to='/magazalar' className='group flex flex-col items-center justify-center gap-2 rounded-card border border-dashed border-brand-200 bg-gradient-to-br from-brand-50 to-indigo-50 p-5 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-400 hover:shadow-card'>
        <span className='inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-brand-600 shadow-card transition-transform group-hover:scale-110'><FaStore size={20} /></span>
        <p className='text-sm font-bold text-slate-800'>{t('home.sellers.ctaTitle')}</p>
        <p className='text-[11px] text-slate-500'>{t('home.sellers.ctaSubtitle')}</p>
        <span className='mt-1 inline-flex items-center gap-1 text-xs font-bold text-brand-700'>{t('buttons.viewShops')} <FaArrowRight size={10} className='transition-transform group-hover:translate-x-0.5' /></span>
    </Link>
    )
}

const SkeletonRow = () => (
    <div className='grid grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4'>
        {[0, 1, 2, 3].map(i => (
            <div key={i} className='rounded-card border border-slate-200 bg-white p-4 shadow-card'>
                <Skeleton radius='card' className='h-16 w-full' />
                <Skeleton radius='card' className='-mt-7 ml-0 h-14 w-14' />
                <Skeleton radius='md' className='mt-3 h-3 w-2/3' />
                <Skeleton radius='md' className='mt-2 h-2.5 w-1/3' />
                <Skeleton radius='md' className='mt-3 h-8 w-full' />
            </div>
        ))}
    </div>
)

const SellerSpotlight = () => {
    const { t } = useTranslation()
    const [sellers, setSellers] = useState([])
    const [loading, setLoading] = useState(true)
    const [errored, setErrored] = useState(false)

    useEffect(() => {
        let cancelled = false
        ;(async () => {
            try {
                const { data } = await api.get('/sellers/active?page=1&limit=8&search=')
                if (cancelled) return
                setSellers(Array.isArray(data?.sellers) ? data.sellers : [])
            } catch (_err) {
                if (cancelled) return
                setErrored(true)
                setSellers([])
            } finally {
                if (!cancelled) setLoading(false)
            }
        })()
        return () => { cancelled = true }
    }, [])

    if (errored) return null   // şəbəkə xətası → səssiz gizlə

    const list = sellers.slice(0, 8)
    // CTA kartı ilə birlikdə ümumi sayı → balanslı grid (boş sağ tərəf olmasın)
    const totalCards = list.length + 1
    const gridClass = totalCards >= 4
        ? 'grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1'
        : totalCards === 3
            ? 'grid-cols-3 md:grid-cols-2 sm:grid-cols-1 max-w-4xl mx-auto'
            : totalCards === 2
                ? 'grid-cols-2 sm:grid-cols-1 max-w-2xl mx-auto'
                : 'grid-cols-1 max-w-sm mx-auto'

    return (
        <section className='w-full max-w-marketplace mx-auto px-4 sm:px-4 md-lg:px-5 lg:px-8 py-6'>
            <SectionHeader
                eyebrow={{ label: t('home.sellers.eyebrow'), tone: 'brand' }}
                title={t('home.sellers.title')}
                subtitle={t('home.sellers.subtitle')}
                action={{ to: '/magazalar', label: t('buttons.viewAll') }}
            />

            {loading ? (
                <SkeletonRow />
            ) : list.length === 0 ? (
                // Boş hal — səliqəli
                <div className='animate-fade-up flex flex-col items-center justify-center rounded-card border border-dashed border-slate-200 bg-slate-50/60 py-12 text-center'>
                    <span className='inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-50 text-brand-500'><FaStore size={24} /></span>
                    <p className='mt-3 text-sm font-bold text-slate-700'>{t('home.sellers.emptyTitle')}</p>
                    <p className='mt-1 text-xs text-slate-400'>{t('home.sellers.emptySubtitle')}</p>
                    <Link to='/magazalar' className='mt-4 inline-flex items-center gap-1.5 rounded-card bg-brand-600 px-4 py-2 text-xs font-bold text-white hover:bg-brand-700 transition-colors'>{t('buttons.viewShops')} <FaArrowRight size={10} /></Link>
                </div>
            ) : (
                <div className={`animate-fade-up grid ${gridClass} gap-4`}>
                    {list.map(s => <SellerProfileCard key={s._id} seller={s} />)}
                    <CtaCard />
                </div>
            )}
        </section>
    )
}

export default SellerSpotlight
